import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PrivateRoute } from "./components/PrivateRoute";
import { App } from "./App";
import { Login } from "./containers/Login/Login";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store/configureStore";
/*
import { SetToastMessage, ShowToastMessage, HideToastMessage } from "./actions/toastActions";
*/
import { ToastMessage } from "./components/ToastMessage/ToastMessage";
import { LocalLogin } from "./containers/Login/LocalLogin";
import { ForgotPassword } from "./containers/Login/Additional/ForgotPassword";
import { ResetPassword } from "./containers/Login/Additional/ResetPassword";
import { toast as toast2, Toaster } from 'react-hot-toast';
import './CustomToast.css';
import { Message } from "semantic-ui-react";
import "./index.css";
import "semantic-ui-css/semantic.min.css";

const store = configureStore();

export const toast = (text: string, success: boolean, timeout: number = 3000) => {
    /*
    const dispatch = store.dispatch;
    dispatch(SetToastMessage(text, success));
    dispatch(ShowToastMessage());
    setTimeout(() => dispatch(HideToastMessage()), timeout);
    */
    const toastComponent = <Message id={`message-toastMessage-${text}`} compact className="toast-message" positive={success} negative={!success}>
        {text}
    </Message>;

    toast2.custom((t) => (
        <div
            className={`toast-container ${!t.visible ? 'toast-exit' : ''}`}
        /*
        onClick={() => toast2.dismiss(t.id)}
        */
        >
            {toastComponent}
        </div>
    ));

};

const root = createRoot(document.getElementById("root")!);
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <Routes>
                <Route path="/login/local" element={<LocalLogin />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/login" element={<Login />} />
                <Route path="/*" element={<PrivateRoute path="/" component={App} />} />
            </Routes>
        </BrowserRouter>
        <ToastMessage />
        <Toaster />
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
